// const controls = document.querySelectorAll(".floorplans .controls button");
// controls.forEach(button => {
// 	button.addEventListener("click", buttonclick)
// });

// const wrapper = document.querySelector(".floorplans .wrapper");
// function buttonclick(event) {
// 	let active_button = document.querySelector("button.active"); // remove active class
// 	if (active_button) active_button.className = "";
// 	event.target.className = "active"; // add active class to the button clicked
// 	const name = event.target.value;
// 	wrapper.className = "wrapper " + name;
// }

const controls = document.querySelectorAll(".floorplan_views__controls button");
controls.forEach(button => {
	button.addEventListener("click", buttonclick);
});
function buttonclick(event) {
	remove_active();
	let clicked = event.target;
	clicked.classList.add("active");
	let target = document.getElementById(clicked.value);
	target.classList.add("active");
}
function remove_active() {
	let active = document.querySelectorAll(".floorplan_views .active");
	if (active) {
		active.forEach(ele => ele.classList.remove("active"));
	}
}


// fire first element
if (controls.length > 0) {
	controls[0].click();
}

